/**
 * Slot Appointment Type Chip Component
 * Displays appointment type with appropriate styling
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import { SlotAppointmentType, SLOT_APPOINTMENT_TYPE_LABELS } from '../../../types/scheduleSlot';

interface SlotAppointmentTypeChipProps {
  type: SlotAppointmentType;
  size?: 'small' | 'medium';
}

const TYPE_COLORS: Record<SlotAppointmentType, 'primary' | 'secondary' | 'info' | 'warning' | 'success'> = {
  [SlotAppointmentType.CONSULTA]: 'primary',
  [SlotAppointmentType.EXAME]: 'info',
  [SlotAppointmentType.RETORNO]: 'secondary',
  [SlotAppointmentType.URGENCIA]: 'warning',
  [SlotAppointmentType.PREVENTIVA]: 'success',
};

export const SlotAppointmentTypeChip: React.FC<SlotAppointmentTypeChipProps> = ({ type, size = 'small' }) => {
  return (
    <Chip
      label={SLOT_APPOINTMENT_TYPE_LABELS[type] || type}
      color={TYPE_COLORS[type] || 'default'}
      size={size}
      variant="filled"
    />
  );
};

export default SlotAppointmentTypeChip;
